"use client";

import { c as _c } from "react/compiler-runtime";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { INotificationDropQuoted } from "@/types/feed.types";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { useRouter } from "next/navigation";
import { ApiDrop } from "@/generated/models/ApiDrop";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
export default function NotificationDropQuoted(t0) {
  const $ = _c(18);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  if ($[0] !== isApp || $[1] !== router) {
    t1 = (waveId, serialNo, isDirectMessage) => {
      router.push(getWaveRoute({
        waveId,
        serialNo,
        isDirectMessage,
        isApp
      }));
    };
    $[0] = isApp;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const navigateToWave = t1;
  let t2;
  if ($[3] !== navigateToWave || $[4] !== notification.related_drops[0].wave) {
    t2 = serialNo_0 => {
      const baseWave = notification.related_drops[0].wave as any;
      const isDirectMessage_0 = baseWave?.chat?.scope?.group?.is_direct_message ?? false;
      navigateToWave(notification.related_drops[0].wave.id, serialNo_0, isDirectMessage_0);
    };
    $[3] = navigateToWave;
    $[4] = notification.related_drops[0].wave;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onReplyClick = t2;
  let t3;
  if ($[6] !== navigateToWave) {
    t3 = quote => {
      const quoteWave = quote.wave as any;
      const isDirectMessage_1 = quoteWave?.chat?.scope?.group?.is_direct_message ?? false;
      navigateToWave(quote.wave.id, quote.serial_no, isDirectMessage_1);
    };
    $[6] = navigateToWave;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onQuoteClick = t3;
  let t4;
  if ($[8] !== notification.related_drops[0]) {
    t4 = {
      type: DropSize.FULL,
      ...notification.related_drops[0],
      stableKey: "",
      stableHash: ""
    };
    $[8] = notification.related_drops[0];
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== activeDrop || $[11] !== onDropContentClick || $[12] !== onQuote || $[13] !== onQuoteClick || $[14] !== onReply || $[15] !== onReplyClick || $[16] !== t4) {
    t5 = <Drop drop={t4} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[10] = activeDrop;
    $[11] = onDropContentClick;
    $[12] = onQuote;
    $[13] = onQuoteClick;
    $[14] = onReply;
    $[15] = onReplyClick;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}